module.exports = __webpack_public_path__ + "static/media/about-2.1a6335d5.jpg";